document.addEventListener('DOMContentLoaded', () => {
  const openers = document.querySelectorAll('.drawer_opener');
  const productInfo = document.querySelector('.product__info');

  let activeDrawer = null;

  const openDrawer = (drawer) => {
    if (!drawer) return;

    activeDrawer = drawer;

    drawer.classList.add('active');
    document.body.classList.add('overflow-hidden');
    productInfo?.classList.add('drawer-opened');
  };

  const closeDrawer = () => {
    if (!activeDrawer) return;

    activeDrawer.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
    productInfo?.classList.remove('drawer-opened');

    activeDrawer = null;
  };

  openers.forEach((opener) => {
    opener.addEventListener('click', (e) => {
      e.preventDefault();

      const id = opener.dataset.target;
      const drawer = document.querySelector(`[data-drawer="${id}"]`);

      if (!drawer) return;

      const overlay = drawer.querySelector('.drawer__overlay');
      const closeBtn = drawer.querySelector('.drawer__close');

      openDrawer(drawer);

      overlay?.addEventListener('click', closeDrawer);
      closeBtn?.addEventListener('click', closeDrawer);
    });
  });
});